import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { BeforeAfter } from './components/BeforeAfter';
import { PainGrid } from './components/PainGrid';
import { WhatsInside } from './components/WhatsInside';
import { Delivery } from './components/Delivery';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { WeekView } from './components/WeekView';
import { Opinions } from './components/Opinions';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23w4e5zrtp20b">
      <AnnouncementBar data-id="element-1" data-mp="23v2sz2h3ez4v" />
      <Hero data-id="element-2" data-mp="3ijxpcqos80jw" />
      <main data-id="element-3" data-mp="3ik7eyd5x05p2">
        <StatsBar data-id="element-4" data-mp="3ikr002qv3a7b" />
        <Transformation data-id="element-5" data-mp="3ij64oawq3n8e" />
        <BeforeAfter data-id="element-6" data-mp="3ijpet5g4t7bv" />
        <PainGrid data-id="element-7" data-mp="3mljat0fdtn5p" />
        <WhatsInside data-id="element-8" data-mp="3ml13n8r6loj0" />
        <Delivery data-id="element-9" data-mp="3mkhnnxl3da7m" />
        <Bonuses data-id="element-10" data-mp="3mjzpuwis6nxl" />
        <Pricing data-id="element-11" data-mp="3mjgczu7zmpqf" />
        <Guarantee data-id="element-12" data-mp="3rc9hqi3ghy2i" />
        <WeekView data-id="element-13" data-mp="3rbzn2h7gv2qh" />
        <Opinions data-id="element-14" data-mp="3rdkhm6ts6loc" />
        <Faq data-id="element-15" data-mp="3rd1all5o5hp3" />
        <FinalCta data-id="element-16" data-mp="3recbnd7qcbci" />
      </main>
      <Footer data-id="element-17" data-mp="6hqffdy0fe4" />
    </div>;
}